import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import AlliedCameraSMP from '../../../../components/SMP/AlliedCamera';
import LightArchSMP from '../../../../components/SMP/LightArch';
import Lights18SMP from '../../../../components/SMP/Lights18';
import Lights25SMP from '../../../../components/SMP/Lights25';
import DoubleWideSMP from '../../../../components/SMP/DoubleWide';
import TriggerBoardSMP from '../../../../components/SMP/TriggerBoard';
import ChannelBoardSMP from '../../../../components/SMP/ChannelBoard';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import AlliedCamera from '../assets/maintenance/5.1-allied-camera.png';
import AlliedConnections from '../assets/maintenance/5.2-allied-camera-connections.png';
import ChannelBoard from '../assets/maintenance/5.3-channel-board.png';
import LEDHeader from '../assets/maintenance/5.4-LED-header-board.png';
import ArchDoubleWide from '../assets/maintenance/5.5-arch-double-wide-LED.png';
import ArchBoards from '../assets/maintenance/5.6-arch-light-boards.png';
import WideBoards from '../assets/maintenance/5.7-LED-wide-light-boards.png';
import ArchConnecions from '../assets/maintenance/5.8-light-arch-connections.png';
import DoubleWideConnections from '../assets/maintenance/5.9-double-wide-connections.png';
import TriggerBoard from '../assets/maintenance/5.10-trigger-board-connections.png';
import ArchHousing from '../assets/maintenance/5.11-arch-light-housing.png';
import DoubleHousing from '../assets/maintenance/5.12-double-wide-housing.png';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const SIMaintenanceOverview = () => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('ALLIED Camera Replacement');
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance Procedures</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 maintenance-element">
								<Tab eventKey="ALLIED Camera Replacement" title="ALLIED Camera Replacement">
									<div class="tab-section" style={{}}>
										<AlliedCameraSMP />
									</div>
								</Tab>

								<Tab eventKey="Channel Board Replacement" title="Channel Board Replacement">
									<ChannelBoardSMP />
								</Tab>

								<Tab eventKey="Trigger Board Replacement" title="Trigger Board Replacement">
									<div class="tab-section" style={{}}>
										<TriggerBoardSMP />
									</div>
								</Tab>

								<Tab eventKey="Light Arch Replacement" title="Light Arch Replacement">
									<div class="tab-section" style={{}}>
										<LightArchSMP />
									</div>
								</Tab>

								<Tab eventKey="Lights 1-8 Replacement" title="Lights 1-8 Replacement">
									<div class="tab-section" style={{}}>
										<Lights18SMP />
									</div>
								</Tab>

								<Tab eventKey="Lights 2-5 Replacement" title="Lights 2-5 Replacement">
									<div class="tab-section" style={{}}>
										<Lights25SMP />
									</div>
								</Tab>

								<Tab eventKey="Double Wide Lights Replacement" title="Double Wide Lights Replacement">
									<div class="tab-section" style={{}}>
										<DoubleWideSMP />
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMaintenanceOverview;
